// extracted by mini-css-extract-plugin
export default {"summaryBox":"summary_summaryBox__+1AM6","subtitle":"summary_subtitle__IgXWW"};